
	(function () {
		var root = document.getElementById('nn-ffmi-template--27862112698462__tool');
		if (!root || root.dataset.nnReady === '1') return;
		root.dataset.nnReady = '1';

		var LB_TO_KG = 0.45359237, IN_TO_M = 0.0254;
		var NATURAL_LIMIT = { male: 25, female: 22 };
		var SCALE_MIN = { male: 14, female: 10 };
		var SCALE_MAX = { male: 30, female: 26 };
		var SLIDER = { male: { min: 4, max: 45 }, female: { min: 10, max: 55 } };
		var DEFAULTS = {
			male: { ft: '5', inch: '10', cm: '178', lb: '180', kg: '82', bf: 18 },
			female: { ft: '5', inch: '5', cm: '165', lb: '150', kg: '68', bf: 28 }
		};

		var BANDS = {
			male: [
				[-Infinity, 'Below average', 'Most of your muscle-building potential is still ahead of you.'],
				[18, 'Average', 'Typical for an adult male who has not trained seriously.'],
				[20, 'Above average', 'Clear evidence of consistent resistance training.'],
				[22, 'Athletic', 'Well trained. You carry noticeably more muscle than most people.'],
				[23.5, 'Superior', 'Advanced. This is years-of-serious-training territory.'],
				[25, 'Very high', 'At or beyond the ceiling researchers recorded in drug-free athletes.'],
				[28, 'Exceptional', 'Beyond the documented natural range by a wide margin.']
			],
			female: [
				[-Infinity, 'Below average', 'Most of your muscle-building potential is still ahead of you.'],
				[14, 'Average', 'Typical for an adult woman who has not trained seriously.'],
				[16, 'Above average', 'Clear evidence of consistent resistance training.'],
				[18, 'Athletic', 'Visibly muscular. You carry noticeably more muscle than most people.'],
				[20, 'Superior', 'Advanced. This is years-of-serious-training territory.'],
				[22, 'Very high', 'At or beyond the ceiling researchers recorded in drug-free athletes.'],
				[24, 'Exceptional', 'Beyond the documented natural range by a wide margin.']
			]
		};

		function bandFor(sex, v) {
			var list = BANDS[sex], match = list[0];
			for (var i = 0; i < list.length; i++) if (v >= list[i][0]) match = list[i];
			return match;
		}

		function bodyFatText(sex, p) {
			if (sex === 'male') {
				if (p <= 6) return 'Stage lean. Striated muscle, visible vascularity.';
				if (p <= 9) return 'Very lean. Abs clearly defined, veins in the arms.';
				if (p <= 12) return 'Lean and athletic. Abs visible without flexing.';
				if (p <= 15) return 'Fit. Some abdominal definition, outline visible.';
				if (p <= 18) return 'Average. Flat stomach, little visible definition.';
				if (p <= 22) return 'Soft. No definition, waist starting to widen.';
				if (p <= 28) return 'Heavier build. Noticeable softness at the midsection.';
				return 'Higher body fat. Little muscle definition visible.';
			}
			if (p <= 14) return 'Stage lean. Striated muscle, visible vascularity.';
			if (p <= 17) return 'Very lean. Abs clearly defined, athletic build.';
			if (p <= 20) return 'Lean and athletic. Abs visible, defined arms and shoulders.';
			if (p <= 23) return 'Fit. Clear muscle tone, some abdominal definition.';
			if (p <= 27) return 'Average. Healthy and soft, limited visible definition.';
			if (p <= 32) return 'Softer build. Little definition, fuller hips and thighs.';
			if (p <= 38) return 'Heavier build. Noticeable softness throughout.';
			return 'Higher body fat. Little muscle definition visible.';
		}

		/* Hodgdon & Beckett. The published equations expect CENTIMETRES; feeding
		   them inches understates body fat by about six points. */
		function navyBodyFat(sex, heightIn, neckIn, waistIn, hipIn) {
			var h = heightIn * 2.54, n = neckIn * 2.54, w = waistIn * 2.54, girth, d;
			if (sex === 'male') {
				girth = w - n;
				if (!(girth > 0)) return null;
				d = 1.0324 - 0.19077 * Math.log(girth) / Math.LN10 + 0.15456 * Math.log(h) / Math.LN10;
			} else {
				if (hipIn == null || isNaN(hipIn)) return null;
				girth = w + hipIn * 2.54 - n;
				if (!(girth > 0)) return null;
				d = 1.29579 - 0.35004 * Math.log(girth) / Math.LN10 + 0.221 * Math.log(h) / Math.LN10;
			}
			var r = 495 / d - 450;
			return isFinite(r) && r > 0 ? r : null;
		}

		var q = function (sel) { return root.querySelector(sel); };
		var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

		var state = { sex: 'male', units: 'imperial' };

		function num(sel) { return parseFloat(q(sel).value); }

		function heightInches() {
			if (state.units === 'metric') {
				var cm = num('[data-cm]');
				return isFinite(cm) ? cm / 2.54 : NaN;
			}
			var f = num('[data-ft]');
			var raw = q('[data-in]').value;
			var i = raw.trim() === '' ? 0 : parseFloat(raw);
			return isFinite(f) && isFinite(i) ? f * 12 + i : NaN;
		}

		function weightPounds() {
			var v = num('[data-weight]');
			if (!isFinite(v)) return NaN;
			return state.units === 'metric' ? v / LB_TO_KG : v;
		}

		function render() {
			var hIn = heightInches(), wLb = weightPounds(), bf = parseFloat(q('[data-bf]').value);
			var hOk = isFinite(hIn) && hIn >= 48 && hIn <= 90;
			var wOk = isFinite(wLb) && wLb >= 60 && wLb <= 500;

			q('[data-height-hint]').hidden = hOk;
			q('[data-weight-hint]').hidden = wOk;
			qa('[data-ft],[data-in],[data-cm]').forEach(function (el) { el.setAttribute('data-invalid', String(!hOk)); });
			q('[data-weight]').setAttribute('data-invalid', String(!wOk));

			q('[data-bf-value]').textContent = String(bf);
			q('[data-bf-text]').textContent = bodyFatText(state.sex, bf);

			if (!hOk || !wOk) return;

			var m = hIn * IN_TO_M, kg = wLb * LB_TO_KG;
			var lean = kg * (1 - bf / 100);
			var ffmi = lean / (m * m);
			var norm = ffmi + 6.1 * (1.8 - m);
			var band = bandFor(state.sex, norm);
			var limit = NATURAL_LIMIT[state.sex];
			var lo = SCALE_MIN[state.sex], hi = SCALE_MAX[state.sex];
			var pos = Math.min(1, Math.max(0, (norm - lo) / (hi - lo)));
			var gatePos = ((limit - lo) / (hi - lo)) * 100;
			var gap = limit - norm;

			q('[data-ffmi]').textContent = norm.toFixed(1);
			q('[data-ffmi-raw]').textContent = ffmi.toFixed(1);
			q('[data-lean]').textContent = String(Math.round(state.units === 'metric' ? lean : lean / LB_TO_KG));
			q('[data-lean-unit]').textContent = state.units === 'metric' ? 'kg' : 'lb';
			q('[data-band]').textContent = band[1];
			q('[data-blurb]').textContent = band[2];
			q('[data-gap]').textContent = gap > 0.05
				? gap.toFixed(1) + ' from the natural ceiling'
				: 'At or beyond the natural ceiling';
			q('[data-fill]').style.width = pos * 100 + '%';
			q('[data-marker]').style.left = pos * 100 + '%';
			q('[data-gate]').style.left = gatePos + '%';
			q('[data-gate-label]').style.left = gatePos + '%';
			q('[data-gate-label]').textContent = 'Natural limit ' + limit;
			q('[data-scale-min]').textContent = String(lo);
			q('[data-scale-max]').textContent = String(hi);

			var near = norm >= limit - 2;
			q('[data-nudge-copy]').textContent = near
				? 'You are close to the natural ceiling. Creatine is the best evidenced way to keep progressing.'
				: 'Lean mass is what moves this number. Protein intake is the lever that builds it.';
			var link = q('[data-nudge-link]');
			link.textContent = near ? 'Shop creatine' : "Shop protein";
			link.setAttribute('href', near ? '/collections/creatine' : "\/collections\/protein-powder");
		}

		function renderEstimator() {
			var isFemale = state.sex === 'female';
			q('[data-hip-group]').hidden = !isFemale;
			q('[data-est-help]').textContent = isFemale
				? 'Neck just below the larynx. Waist at the narrowest point. Hips at the widest point.'
				: 'Neck just below the larynx. Waist at the navel.';

			var metric = state.units === 'metric';
			qa('[data-est-unit]').forEach(function (el) { el.textContent = metric ? 'cm' : 'in'; });
			q('[data-est-unit-word]').textContent = metric ? 'centimetres' : 'inches';

			var toIn = function (el) {
				var v = parseFloat(el.value);
				if (!isFinite(v)) return NaN;
				return metric ? v / 2.54 : v;
			};
			var est = navyBodyFat(state.sex, heightInches(), toIn(q('[data-neck]')), toIn(q('[data-waist]')), isFemale ? toIn(q('[data-hip]')) : undefined);
			var ok = est !== null && est >= 3 && est <= 60;
			q('[data-est-out]').textContent = ok ? est.toFixed(1) + '%' : '––';
			q('[data-estimator-apply]').disabled = !ok;
			q('[data-estimator-apply]').dataset.value = ok ? String(Math.round(est)) : '';
		}

		qa('[data-sex]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				state.sex = btn.getAttribute('data-sex');
				qa('[data-sex]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
				var d = DEFAULTS[state.sex];
				q('[data-ft]').value = d.ft; q('[data-in]').value = d.inch; q('[data-cm]').value = d.cm;
				q('[data-weight]').value = state.units === 'metric' ? d.kg : d.lb;
				var slider = q('[data-bf]');
				slider.min = SLIDER[state.sex].min; slider.max = SLIDER[state.sex].max; slider.value = d.bf;
				render(); renderEstimator();
			});
		});

		qa('[data-units]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				var next = btn.getAttribute('data-units');
				if (next === state.units) return;
				var d = DEFAULTS[state.sex];
				state.units = next;
				qa('[data-units]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
				q('[data-imperial]').hidden = next === 'metric';
				q('[data-metric]').hidden = next !== 'metric';
				q('[data-weight-unit]').textContent = next === 'metric' ? 'kg' : 'lb';
				q('[data-weight]').value = next === 'metric' ? d.kg : d.lb;
				q('[data-weight]').setAttribute('aria-label', next === 'metric' ? 'Weight in kilograms' : 'Weight in pounds');
				render(); renderEstimator();
			});
		});

		qa('[data-ft],[data-in],[data-cm],[data-weight]').forEach(function (el) {
			el.addEventListener('input', function () { render(); renderEstimator(); });
		});
		q('[data-bf]').addEventListener('input', render);
		qa('[data-neck],[data-waist],[data-hip]').forEach(function (el) {
			el.addEventListener('input', renderEstimator);
		});

		q('[data-estimator-toggle]').addEventListener('click', function () {
			q('[data-estimator]').hidden = false;
			renderEstimator();
			q('[data-neck]').focus();
		});
		q('[data-estimator-close]').addEventListener('click', function () {
			q('[data-estimator]').hidden = true;
		});
		q('[data-estimator-apply]').addEventListener('click', function () {
			var v = q('[data-estimator-apply]').dataset.value;
			if (!v) return;
			q('[data-bf]').value = v;
			q('[data-estimator]').hidden = true;
			render();
		});

		render();
	})();
